export type SupportedLang = 'en' | 'fr';

/**
 * Maps any language code ('fr', 'fr-FR', 'fr_FR', 'FR'...) to a supported language;
 * anything else, or no language at all (some webviews don't expose one), is English.
 */
export function supportedLang(lang: string | null | undefined): SupportedLang {
  return (lang ?? '').slice(0, 2).toLowerCase() === 'fr' ? 'fr' : 'en';
}

/** `lang` query param of the page URL, readable before the router has finished navigating. */
export function urlLang(): string | null {
  return new URLSearchParams(window.location.search).get('lang');
}

// Changes on every app load: browsers that cached the translation files with the old
// year-long "immutable" header would otherwise never fetch the updated ones.
const I18N_CACHE_BUSTER = `v=${Date.now()}`;

/** URL of a translation file, bypassing stale browser caches. */
export function i18nUrl(lang: string): string {
  return `/assets/i18n/${lang}.json?${I18N_CACHE_BUSTER}`;
}

export const I18N_URL_SUFFIX = `.json?${I18N_CACHE_BUSTER}`;
